import { NgModule } from '@angular/core';

import { CoreModule } from '../core/core.module';
import { RclExcaliburModule } from '@rccl/rcl-excalibur';
import { CommonModule } from '@angular/common';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { ModalContentComponent } from './modal-content/modal-content.component';
import { ModalCruiseHistoryComponent } from './modal-cruise-history/modal-cruise-history.component';
import { PromptComponent } from './prompt/prompt.component';
import { SessionTimeoutComponent } from './session-timeout/session-timeout.component';
import { OlciPromptsInnerComponent } from './olci-prompts/olci-prompts-inner.component';
import { OlciPromptsComponent } from './olci-prompts/olci-prompts.component';
import { ModalExitConfirmationComponent } from './modal-exit-confirmation/modal-exit-confirmation.component';
import { ModalCurrencyConversionComponent } from './modal-currency-conversion/modal-currency-conversion.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalMobileAppComponent } from './modal-mobile-app/modal-mobile-app.component';
import { ModalBiometricsPrivacyComponent } from './modal-biometrics-privacy/modal-biometrics-privacy.component';
import { ModalTermsOfUseComponent } from './modal-terms-of-use/modal-terms-of-use.component';
import { ModalGovernanceContentComponent } from './modal-governance-content/modal-governance-content.component';
import { ModalVaccinationReminderComponent } from './modal-vaccination-reminder/modal-vaccination-reminder.component';
import { BrowserUtils } from './../../utils/browser.utils';

@NgModule({
	imports: [CoreModule, CommonModule, ReactiveFormsModule, RclExcaliburModule],
	declarations: [
		OlciPromptsComponent,
		OlciPromptsInnerComponent,
		LanguageSelectorComponent,
		ModalContentComponent,
		ModalCruiseHistoryComponent,
		ModalCurrencyConversionComponent,
		PromptComponent,
		SessionTimeoutComponent,
		ModalExitConfirmationComponent,
		ModalMobileAppComponent,
		ModalBiometricsPrivacyComponent,
		ModalTermsOfUseComponent,
		ModalGovernanceContentComponent,
		ModalVaccinationReminderComponent,
	],
	exports: [
		OlciPromptsComponent,
		OlciPromptsInnerComponent,
		LanguageSelectorComponent,
		ModalContentComponent,
		ModalCruiseHistoryComponent,
		ModalCurrencyConversionComponent,
		PromptComponent,
		SessionTimeoutComponent,
		ModalExitConfirmationComponent,
		ModalMobileAppComponent,
		ModalBiometricsPrivacyComponent,
		ModalTermsOfUseComponent,
		ModalGovernanceContentComponent,
		ModalVaccinationReminderComponent,
	],
	providers: [BrowserUtils]
})
export class PromptsModule {}
